import { create } from "zustand";
import { persist } from "zustand/middleware";

type AuthState = {
  user: { id: string; email: string; name: string | null } | null;
  token: string | null;
  isAuthenticated: boolean;

  login: (session: {
    user: AuthState["user"];
    token?: string | null;
  }) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      login: ({ user, token }) =>
        set({
          user,
          token: token ?? null,
          isAuthenticated: true,
        }),

      logout: () =>
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: "widget-auth",
      partialize: (s) => ({
        user: s.user,
        token: s.token,
        isAuthenticated: s.isAuthenticated,
      }),
    }
  )
);
